/**
 * O padrão selecionado — seletor global do frame de Compliance (handoff v4 §6).
 *
 * 🔒 Vive na URL (`?padrao=<id>`), e não em estado de React: o frame e a tela são
 * rotas diferentes, um link compartilhado abre no mesmo padrão, e o `padraoId`
 * entra em toda query key por cliente — trocar de padrão troca a chave.
 *
 * Sem `?padrao=`, o padrão é o mais recente com status `ativo`; sem nenhum ativo, o
 * mais recente. A lista chega ordenada por ano desc (contrato).
 */
import { useSearchParams } from 'react-router'

import type { Padrao } from '@/api/contracts/compliance'
import { usePadroes } from '@/api/queries/compliance'

export const PARAMETRO_PADRAO = 'padrao'

export function padraoPadrao(padroes: readonly Padrao[]): Padrao | undefined {
  return padroes.find((p) => p.status === 'ativo') ?? padroes[0]
}

export function usePadraoSelecionado() {
  const [params, setParams] = useSearchParams()
  const consulta = usePadroes()
  const padroes = consulta.data ?? []
  const pedido = params.get(PARAMETRO_PADRAO)
  const padrao = padroes.find((p) => p.id === pedido) ?? padraoPadrao(padroes)

  function selecionar(id: string) {
    setParams((atuais) => {
      const proximos = new URLSearchParams(atuais)
      proximos.set(PARAMETRO_PADRAO, id)
      return proximos
    })
  }

  return { consulta, padroes, padrao, selecionar }
}

/** `?padrao=<id>` para carregar a seleção ao trocar de aba — ou vazio. */
export function sufixoDoPadrao(search: string): string {
  const id = new URLSearchParams(search).get(PARAMETRO_PADRAO)
  return id ? `?${PARAMETRO_PADRAO}=${encodeURIComponent(id)}` : ''
}
